export interface Address {
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  country?: string | null;
}

export function formatAddress(address: Address): string | undefined {
  if (!address) return undefined;

  const params = [
    address?.addressLine1?.trim(),
    address?.addressLine2?.trim(),
    address?.addressLine3?.trim(),
    address?.city?.trim(),
    address?.state?.trim(),
    address?.postcode?.trim(),
    address?.country?.trim(),
  ];

  const filledParams = params.filter(Boolean);

  if (filledParams.length > 0) return filledParams.join(', ');

  return undefined;
}
